import React from "react";
import lottie from "lottie-web";
import PropTypes from "prop-types";
import animation from "./LongestStreak.json";
import { EVENT, STATE } from "./LongestStreakPlayer.contants";

/**
 * LongestStreakPlayer:
 *  Handles Animation playback of LongestStreak Animation
 */
export class LongestStreakPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.elementRef = React.createRef();
    this.state = {
      anime: null,
    };
  }

  playbackCompleted = (event) => {
    if (event.type === EVENT.COMPLETE) {
      this.state.anime.stop();
      this.props.playComplete(STATE.ACTIVE.KEY);
    }
  };

  applyStateAction = (anime) => {
    if (this.props.state === STATE.INACTIVE.KEY) {
      anime.goToAndStop(STATE.INACTIVE.VALUE, true);
    } else if (this.props.state === STATE.ACTIVE.KEY) {
      anime.goToAndStop(STATE.ACTIVE.VALUE, true);
    } else {
      anime.playSegments(STATE.PLAY.VALUE, true);
    }
  };

  componentDidMount() {
    const anime = getLottieInstance(this.elementRef.current);
    anime.addEventListener(EVENT.COMPLETE, this.playbackCompleted);
    this.setState({ anime });
    this.applyStateAction(anime);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.state === STATE.PLAY.KEY) {
      // after PLAY action the frame number of animation changes
      // this needs to be reset for properly setting INACTIVE state
      this.state.anime.playSegments([0, 49], true);
    }
    if (prevProps.state !== this.props.state) {
      this.applyStateAction(this.state.anime);
    }
  }

  componentWillUnmount() {
    this.state.anime.removeEventListener(
      EVENT.COMPLETE,
      this.playbackCompleted
    );
    this.setState({ anime: null });
  }

  render() {
    return <div className={this.props.className} ref={this.elementRef} />;
  }
}

LongestStreakPlayer.propTypes = {
  /**
   * ClassName to set on component
   */
  className: PropTypes.string,
  /**
   * Current animation play state
   */
  state: PropTypes.oneOf(["ACTIVE", "INACTIVE", "PLAY"]),
  /**
   * Callback for when Animation playback complete [ on PLAY state]
   */
  playComplete: PropTypes.func,
};

LongestStreakPlayer.defaultProps = {
  state: "INACTIVE",
  playComplete: console.log,
};

function getLottieInstance(container) {
  return lottie.loadAnimation({
    loop: false,
    autoplay: false,
    container: container,
    animationData: animation,
  });
}
